// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Implantacao_JornadasResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * GET /implantacao/minha (as jornadas das franquias do franqueado) e GET /implantacao/lista
 * (todas, para a franqueadora). Chamado NS 2026-0079.
 */
import type { Implantacao_JornadaRow } from './Implantacao_JornadaRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Implantacao_JornadasResponseDados {
jornadas: Implantacao_JornadaRow[]
}

export type Implantacao_JornadasResponse = ApiResponse<Implantacao_JornadasResponseDados>;

registerResponseContract('Implantacao_JornadasResponse', {
  jornadas: {
    type: 'array',
    required: true,
    items: {
      franquia_id:             { type: 'number',  required: true },
      franquia_nome:           { type: 'string',  required: false },
      situacao:                { type: 'string',  required: true },
      checklist_versao:        { type: 'number',  required: false },
      percentual:              { type: 'number',  required: false },
      etapa_atual:             { type: 'string',  required: false },
      operacao_liberada:       { type: 'boolean', required: false },
      operacao_liberada_em:    { type: 'string',  required: false },
      criada_em:               { type: 'string',  required: false },
      atualizada_em:           { type: 'string',  required: false },
      pendencias_franqueado:   { type: 'number',  required: false },
      pendencias_franqueadora: { type: 'number',  required: false },
      etapas: {
        type: 'array',
        required: false,
        items: {
          chave:    { type: 'string',  required: true },
          titulo:   { type: 'string',  required: true },
          ordem:    { type: 'number',  required: true },
          situacao: { type: 'string',  required: true },
          itens: {
            type: 'array',
            required: false,
            items: {
              chave:           { type: 'string',  required: true },
              titulo:          { type: 'string',  required: true },
              descricao:       { type: 'string',  required: false },
              tipo:            { type: 'string',  required: true },
              responsavel:     { type: 'string',  required: true },
              obrigatorio:     { type: 'boolean', required: false },
              automatico:      { type: 'boolean', required: false },
              libera_operacao: { type: 'boolean', required: false },
              travado:         { type: 'boolean', required: false },
              extra:           { type: 'boolean', required: false },
              situacao:        { type: 'string',  required: true },
              motivo:          { type: 'string',  required: false },
              resposta:        { type: 'string',  required: false },
              data_referencia: { type: 'string',  required: false },
              arquivo_nome:    { type: 'string',  required: false },
              atualizado_por:  { type: 'string',  required: false },
              atualizado_em:   { type: 'string',  required: false },
            },
          },
        },
      },
    },
  },
})
